import { combineReducers } from 'redux';

import activitySplit from './activitySplit';
import session from './session';

export default combineReducers({
  activitySplit,
  session,
});
